import standardAPI from '@/api/standard_items';

const state = {
  clients: [],
  clients_status: '',
  clients_search_status: '',
  clients_MetaData: {},
  clients_page: 1,
  clients_perPage: 10,
};

const responseUrl = '/users';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_clients ({ commit }, getOptions) {
    commit('CLIENTS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('CLIENTS_SUCCESS', response);
            commit('CLIENTS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('CLIENTS_READY');
            reject(response);
          } else {
            commit('CLIENTS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_client_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: getOptions.url || responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_client ({ commit, dispatch }, itemData) {
    commit('CLIENTS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('CLIENTS_READY');
          resolve(response);
        } else {
          commit('CLIENTS_READY');
          reject(response);
        }
      });
    });
  },
  edit_client ({ commit, dispatch }, itemData) {
    commit('CLIENTS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('CLIENTS_READY');
          resolve(response);
        } else {
          commit('CLIENTS_READY');
          reject(response);
        }
      });
    });
  },
  remove_client ({ commit, dispatch }, itemData) {
    commit('CLIENTS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('CLIENTS_READY');
          resolve();
        } else {
          commit('CLIENTS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_client ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.clients_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.clients_perPage = max;
  },
  CLIENTS_READY: (state) => {
    state.clients_status = 'ready';
  },
  CLIENTS_REQUEST: (state) => {
    state.clients_status = 'loading';
  },
  CLIENTS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.clients_MetaData.meta = response.meta;
      state.clients_MetaData.links = response.links;
    }
    state.clients = response.data;
    state.clients_status = 'success';
  },
  CLIENTS_ERROR: (state) => {
    state.clients_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
